/**
 * True when any is true:
 * - npm run start:dev:zd:staging is run
 * - npm run start:dev:zd:preview is run
 * - deploying on *.zendesk.com
 * - deploying on *.zendesk-staging.com
 */
export function useIsZendeskBuild(): boolean {
  return IS_ZENDESK_BUILD || IS_ZENDESK_UI_PREVIEW;
}
